import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { Paths } from '../../enums/route-paths.enum';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactComponent } from './contact/contact.component';
import { CoursesComponent } from './courses/courses.component';
import { EventsComponent } from './events/events.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { CategoryCoursesComponent } from './category-courses/category-courses.component';
import { SubCategoryCourseComponent } from './sub-category-course/sub-category-course.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: Paths.home, component: HomeComponent },
  { path: Paths.events, component: EventsComponent },
  { path: Paths.aboutus, component: AboutUsComponent },
  { path: Paths.login, component: LoginComponent },
  { path: Paths.register, component: RegisterComponent },
  { path: Paths.contact, component: ContactComponent },
  { path: Paths.coursesCategory, component: CategoryCoursesComponent },
  { path: Paths.courseSubCategory, component: SubCategoryCourseComponent },
  { path: Paths.course, component: CoursesComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserPanelRoutingModule { }
